module.exports = __webpack_public_path__ + "src/img/error.efea61b3.svg";